import axios from 'axios';
import apiConfig from '../../api.config';
import { gzipSync } from 'fflate';

export default async function invoiceUploadDocumentTemplate(hotelId, chainId, lang, file) {
  const {
    host,
    URIs: { invoiceUploadDocumentTemplate },
  } = apiConfig;

  const uri = `${host}${invoiceUploadDocumentTemplate}`
    .replace(':chainId', chainId)
    .replace(':hotelId', hotelId)
    .replace(':lang', lang);

  const buffer = await file.arrayBuffer();
  const compressed = gzipSync(new Uint8Array(buffer));

  const compressedFile = new File([compressed], 'invoice_template.docx.gz', {
    type: 'application/gzip',
  });

  const formData = new FormData();
  formData.append('file', compressedFile);
  for (const pair of formData.entries()) {
    console.log(pair[0], pair[1]);
  }

  const response = await axios.put(uri, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
}
